import { Breadcrumbs, Group, Text } from '@mantine/core';
import { Link, LinkProps } from '@tanstack/react-router';
import { PropsWithChildren } from 'react';
import { ReactNode } from 'react';

export interface CrumbItem {
    label: ReactNode;
    active?: boolean;
    linkProps?: LinkProps;
}

export function AppBreadcrumbs(props: { items: CrumbItem[] } & PropsWithChildren) {
    const { items } = props;

    return (
        <Group mb={10} align="center" gap={10}>
            <Breadcrumbs className="no-underline">
                {items.map((item, i) => {
                    const color = item.active ? 'var(--mantine-primary-color-filled)' : 'gray';
                    const weight = item.active ? 500 : undefined;

                    return item.linkProps ? (
                        <Link key={i} {...item.linkProps}>
                            <Text c={color} fw={weight}>
                                {item.label}
                            </Text>
                        </Link>
                    ) : (
                        <Text key={i} c={color} fw={weight}>
                            {item.label}
                        </Text>
                    );
                })}
            </Breadcrumbs>
            {props.children}
        </Group>
    );
}
